/* ============================================================
   Logo Blend Mode — logo-blend-mode.js
   ============================================================ */

(function () {
  function initLogoBlend() {
    /* Desktop only — mobile has its own logo in header__mobile */
    if (window.innerWidth <= 749) return;

    /* Target the actual visible desktop logo */
    var logoImg = document.querySelector('.header__desktop__bar__l .header__logo__link img');
    if (!logoImg) return;

    var logoLink = logoImg.closest('.header__logo__link');
    if (!logoLink) return;

    /* Hide original */
    logoImg.style.visibility = 'hidden';

    function buildClone() {
      var rect = logoImg.getBoundingClientRect();
      if (rect.width === 0) { setTimeout(buildClone, 100); return; }

      var w = rect.width;
      var h = rect.height;

      /* Remove any previous clone */
      var existing = document.getElementById('logo-blend-clone');
      if (existing) existing.remove();

      /* Blend wrapper — appended to body to escape all stacking contexts */
      var blendEl = document.createElement('div');
      blendEl.id = 'logo-blend-clone';
      blendEl.style.cssText = [
        'position:fixed',
        'top:' + rect.top + 'px',
        'left:' + rect.left + 'px',
        'width:' + w + 'px',
        'height:' + h + 'px',
        'mix-blend-mode:difference',
        'pointer-events:none',
        'z-index:99999',
        'overflow:hidden'
      ].join(';');

      /* Separate child for filter — cannot be on same element as mix-blend-mode */
      var filterEl = document.createElement('div');
      filterEl.style.cssText = 'width:100%;height:100%;filter:invert(1);';

      var cloneImg = document.createElement('img');
      cloneImg.src = logoImg.currentSrc || logoImg.src;
      cloneImg.style.cssText = 'width:' + w + 'px;height:' + h + 'px;display:block;';

      filterEl.appendChild(cloneImg);
      blendEl.appendChild(filterEl);
      document.body.appendChild(blendEl);

      /* Keep position in sync */
      function sync() {
        var r = logoImg.getBoundingClientRect();
        blendEl.style.top  = r.top  + 'px';
        blendEl.style.left = r.left + 'px';
      }

      window.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
    }

    buildClone();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoBlend);
  } else {
    initLogoBlend();
  }
})();